import type { TemplateTypeMap } from "../types/templateTypes";
import type { Specialty } from "../types/doctorTypes";
import { SPECIALTIES } from "./doctorData";

export enum TemplateType {
  MEDICAL = "medical",
  COMMUNICATIONS = "communications",
  RECORDSRECAP = "recordsrecap",
}

// All templates for specialties
export const PREBUILT_TEMPLATES: Partial<Record<Specialty, TemplateTypeMap>> = {
  [SPECIALTIES.GENERAL_PRACTICE]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_soap_advanced",
        name: "SOAP w/ Physical",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
      {
        id: "dynamic_soap_notes",
        name: "SOAP Notes",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
      {
        id: "dynamic_phone_summary",
        name: "Phone Call - Summary",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
    ],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_records_recap_basic",
        name: "Records Summary",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
      {
        id: "dynamic_records_recap_timeline",
        name: "Records Timeline",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [
      {
        id: "dynamic_simple_discharge",
        name: "Discharge",
        owner: "VetRec_Comms",
        organization: "VetRec_Comms",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.COMMUNICATIONS,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
      {
        id: "dynamic_email_communications",
        name: "Email Communications",
        owner: "VetRec_Comms",
        organization: "VetRec_Comms",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.COMMUNICATIONS,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
      {
        id: "dynamic_rdvm_letter",
        name: "rDVM Letter",
        owner: "VetRec_Comms",
        organization: "VetRec_Comms",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.COMMUNICATIONS,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
      {
        id: "dynamic_kids_story",
        name: "Kids Story",
        owner: "VetRec_Comms",
        organization: "VetRec_Comms",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.COMMUNICATIONS,
        tag: [SPECIALTIES.GENERAL_PRACTICE],
      },
    ],
  },
  [SPECIALTIES.ACUPUNCTURE]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_acupuncture_soap",
        name: "Acupuncture SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.ACUPUNCTURE, "specialty"],
      },
      {
        id: "dynamic_acupuncture_session_summary",
        name: "Acupuncture Session Summary",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.ACUPUNCTURE, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.AVIAN]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_avian",
        name: "Avian SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.AVIAN, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.AQUATICS]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_exotics_fish_physical_exam",
        name: "Fish Physical Exam",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.AQUATICS, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.ANESTHESIA]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_anesthesia_soap",
        name: "Anesthesia SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.ANESTHESIA, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.NEUROLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_neurology",
        name: "Neurology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.NEUROLOGY, "specialty"],
      },
      {
        id: "dynamic_neurology_physical_exam",
        name: "Neurology Physical",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.NEUROLOGY, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_neurology_history_summary",
        name: "Neurology History Summary",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.NEUROLOGY, "specialty"],
      },
    ],
  },
  [SPECIALTIES.NEPHROLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_nephrology_soap",
        name: "Nephrology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.NEPHROLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.NUTRITION]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_nutrition_soap",
        name: "Nutrition SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.NUTRITION, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.CARDIOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_cardiology_soap",
        name: "Cardiology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.CARDIOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [
      {
        id: "dynamic_cardiology_discharge",
        name: "Cardiology Discharge",
        owner: "VetRec_Comms",
        organization: "VetRec_Comms",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.COMMUNICATIONS,
        tag: [SPECIALTIES.CARDIOLOGY, "specialty"],
      },
    ],
  },
  [SPECIALTIES.BEHAVIOR]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_behavior_soap_initial_full",
        name: "Behavior SOAP Initial",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.BEHAVIOR, "specialty"],
      },
      {
        id: "dynamic_behavior_soap_progress_evaluation",
        name: "Behavior SOAP Progress Eval",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.BEHAVIOR, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_behavior_history_summary",
        name: "Behavior History Summary",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.BEHAVIOR, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.IMMUNOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_immunology_soap",
        name: "Immunology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.IMMUNOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.INTERNAL_MEDICINE]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_internal_medicine_soap",
        name: "Internal Medicine SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.INTERNAL_MEDICINE, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_internal_medicine_history",
        name: "Internal Medicine History",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.INTERNAL_MEDICINE, "specialty"],
      },
    ],
  },
  [SPECIALTIES.DERMATOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_dermatology_soap",
        name: "Dermatology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.DERMATOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_dermatology_history",
        name: "Dermatology History",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.DERMATOLOGY, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.EXOTICS]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_rabbit_rodent",
        name: "Rabbit + Rodent SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.EXOTICS, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.ONCOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_oncology_physical_exam",
        name: "Oncology Physical Exam",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.ONCOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_oncology_history",
        name: "Oncology History",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.ONCOLOGY, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.OPHTHALMOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_ophthalmology_soap",
        name: "Ophthalmology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.OPHTHALMOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.REHAB]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_rehab_exam",
        name: "Rehab Physical Exam",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.REHAB, "specialty"],
      },
      {
        id: "dynamic_rehab_progress",
        name: "Rehab Progress Notes",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.REHAB, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.EMERGENCY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_er",
        name: "ER SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.EMERGENCY, "specialty"],
      },
      {
        id: "dynamic_rounds_notes",
        name: "ER Rounds Notes",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.EMERGENCY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.EQUINE]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_equine_physical",
        name: "Equine Physical Exam",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.EQUINE, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.RADIOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_radiology_soap",
        name: "Radiology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.RADIOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.SURGERY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_surgery_report",
        name: "Surgery Report",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.SURGERY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_surgery_history_summary",
        name: "Surgery History Summary",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.SURGERY, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.TOXICOLOGY]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_toxicology_soap",
        name: "Toxicology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.TOXICOLOGY, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.DENTAL]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_canine_dental",
        name: "Canine Dental",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.DENTAL, "specialty"],
      },
      {
        id: "dynamic_feline_dental",
        name: "Feline Dental",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.DENTAL, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [
      {
        id: "dynamic_dental_history_summary",
        name: "Dental History Summary",
        owner: "VetRec_RecordsRecap",
        organization: "VetRec_RecordsRecap",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.RECORDSRECAP,
        tag: [SPECIALTIES.DENTAL, "specialty"],
      },
    ],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.REPRODUCTION]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_reproduction_soap",
        name: "Theriogenology SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.REPRODUCTION, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.PALLIATIVE_CARE]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_palliative_care_soap",
        name: "Palliative Care SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.PALLIATIVE_CARE, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
  [SPECIALTIES.PREVENTIVE_MEDICINE]: {
    [TemplateType.MEDICAL]: [
      {
        id: "dynamic_preventive_medicine_soap",
        name: "Preventive Medicine SOAP",
        owner: "VetRec",
        organization: "VetRec",
        created_timestamp: Date.now(),
        modified_timestamp: Date.now(),
        type: TemplateType.MEDICAL,
        tag: [SPECIALTIES.PREVENTIVE_MEDICINE, "specialty"],
      },
    ],
    [TemplateType.RECORDSRECAP]: [],
    [TemplateType.COMMUNICATIONS]: [],
  },
};

// default GP templates
export const DEFAULT_GP_TEMPLATE_IDS = {
  [TemplateType.MEDICAL]: "dynamic_soap_advanced",
  [TemplateType.COMMUNICATIONS]: "dynamic_simple_discharge",
  [TemplateType.RECORDSRECAP]: "dynamic_records_recap_basic",
};
